import { IWDDesignModeProps } from "../common";
import { IContextProvider } from "../../../uxp";
import { generateUUID, hasValue, parseValue, tryParseJSON } from "../../../util";
import * as jsonpath from "jsonpath";
import { IContextData } from "../../../hooks/useContextData";
import { cloneDeep } from 'lodash-es'
import { IQuery } from "lucy/query-builder";
import {
    ICollection,
    ICustomJsonDataSource,
    IDataSource,
    IDataSourceBinding,
    IDataSourceParameter,
    IExternalDatabaseDataSource,
    IModelAction,
    IModelCollectionDataSource,
    IQueryDataSource,
    ModelDefinition,
    TargetDataStructure,
} from "./datasource-types";
import {
    combinePaths,
    DEFAULT_SCHEMA,
    deriveJSONPath,
    isExternalDatabase,
    isModelCollection,
    schemaAtJsonPath,
    validateSchema,
} from "./datasource-schema";

export const DEFAULT_ICON = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Mi4zMiA0Mi4zMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM3MjViN2E7fS5jbHMtMntmaWxsOiNlYmQxNzc7fS5jbHMtM3tmaWxsOiMwNTA1MDU7fS5jbHMtMywuY2xzLTQsLmNscy01LC5jbHMtNntzdHJva2U6IzcyNWI3YTtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9LmNscy0zLC5jbHMtNCwuY2xzLTZ7c3Ryb2tlLXdpZHRoOjAuNXB4O30uY2xzLTR7ZmlsbDojY2ViMTVmO30uY2xzLTUsLmNscy02e2ZpbGw6bm9uZTtzdHJva2UtbGluZWNhcDpyb3VuZDtvcGFjaXR5OjAuODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFzc2V0IDM5PC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMjEuMTYiIGN5PSIyMS4xNiIgcj0iMjEuMTYiLz48cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjEyLjEiIHk9IjExLjc4IiB3aWR0aD0iMTguMTIiIGhlaWdodD0iMTguMTIiIHJ4PSIzIiByeT0iMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4zMiA0Mikgcm90YXRlKC05MCkiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMyIgY3g9IjEyLjEiIGN5PSIyNC41MSIgcj0iMS42MiIvPjxjaXJjbGUgY2xhc3M9ImNscy00IiBjeD0iMzAuMjIiIGN5PSIxNy44MSIgcj0iMS42MiIvPjxjaXJjbGUgY2xhc3M9ImNscy00IiBjeD0iMzAuMjIiIGN5PSIyNC41MSIgcj0iMS42MiIvPjxsaW5lIGNsYXNzPSJjbHMtNSIgeDE9IjE1LjY5IiB5MT0iMTYuMDEiIHgyPSIyNC43NSIgeTI9IjE2LjAxIi8+PGxpbmUgY2xhc3M9ImNscy02IiB4MT0iMTUuNjkiIHkxPSIxOC4wNiIgeDI9IjI0Ljc1IiB5Mj0iMTguMDYiLz48bGluZSBjbGFzcz0iY2xzLTYiIHgxPSIxNS42OSIgeTE9IjI2LjMxIiB4Mj0iMjMuNDQiIHkyPSIyNi4zMSIvPjxsaW5lIGNsYXNzPSJjbHMtNiIgeDE9IjE1LjY5IiB5MT0iMjQuOTYiIHgyPSIyNS43NSIgeTI9IjI0Ljk2Ii8+PC9nPjwvZz48L3N2Zz4=';

export function registerDataSource(ds: IDataSource, id?: string) {
    if (!hasValue(id)) id = generateUUID();
    return Object.assign({}, ds, { id });
}

export function findDataSource(id: string, sources: IDataSource[]) {
    if (!sources) return null;
    return sources.find(x => x.id == id);
}

export function dataSourceLabel(ds: IDataSource) {
    console.log('dataspirce ', ds);

    if (ds.type == 'model-action') return `${ds.model}.${ds.action}`;
    if (ds.type == 'custom-json') return (ds as ICustomJsonDataSource).name || ''
    if (ds.type == 'model-collection') return `collection:${ds.model}.${ds.action}`
}

export function getDependencyParameters(bindings: IDataSourceBinding[], sources: IDataSource[], contextData: any) {

    let deps: any[] = [];
    if (!bindings) {
        return deps;
    }
    for (let binding of bindings) {
        if (!binding) {
            continue;
        }
        let ds = findDataSource(binding.source, sources);
        if (!ds) {
            continue;
        }
        let sourceParameters = ds.parameters;
        for (let p of sourceParameters) {
            let v = parseValue(p.value, contextData);
            deps.push(v);
        }
    }
    return deps;
}

export function findAvailableFields(binding: IDataSourceBinding, sources: IDataSource[]) {
    let results: any = {};
    let t = binding;
    let source = sources?.find(x => x.id == t?.source);
    if (source) {
        let path = binding?.path;

        let targetSchema = (schemaAtJsonPath(source.schema, path));
        if (targetSchema?.type == 'array') {
            if (targetSchema.items?.type == 'object') {
                let required = Object.keys(targetSchema.items?.properties || {});
                for (let r of required) {
                    results[r] = '1';
                }
            }
        }

    }
    let pv = Object.keys(results);
    pv.sort();
    return pv;

};


function parseToArray(value: any): any[] {
    if (Array.isArray(value)) {
        return value;
    }
    if (typeof value === 'string') {
        try {
            const parsedArray = JSON.parse(value);
            if (Array.isArray(parsedArray)) {
                return parsedArray;
            }
        } catch (e) {
            // Not a JSON stringified array
        }
        return value.split(',').map(item => item.trim());
    }
    return [];
}

function recursivelyParseConditions(condition: any, data: any): any {
    if (Array.isArray(condition)) {
        return condition.map(c => recursivelyParseConditions(c, data));
    } else if (typeof condition === 'object' && condition !== null) {
        const parsedCondition: any = {};
        for (const key in condition) {
            if (condition.hasOwnProperty(key)) {
                if (typeof condition[key] === 'object' && condition[key] !== null) {
                    parsedCondition[key] = recursivelyParseConditions(condition[key], data);
                } else {
                    let parsedValue = parseValue(condition[key], data);
                    if (key === '$in') {
                        parsedValue = parseToArray(parsedValue);
                    }
                    parsedCondition[key] = parsedValue;
                }
            }
        }
        return parsedCondition;
    } else {
        return parseValue(condition, data);
    }
}

function interpolateFilters(filter: any, data: any) {
    if (!filter) return filter;
    if (!data) return filter;
    try {
        const parsedFilters = recursivelyParseConditions(filter, data)
        return parsedFilters
    } catch (e) {
        console.log('Error interpolating filter', filter, data, e);
        return filter;
    }
}


function parseQuery(query: IQuery, contextData: IContextData): IQuery {
    if (!query) return { sources: [], steps: [] }
    if (!contextData) return query

    const parsedSources = (query?.sources || []).map(s => {
        const params = (s?.params || []).map(p => {
            p.value = parseValue(p?.value, contextData);
            return p;
        })
        s.params = params;
        return s;
    })
    const parsedSteps = recursivelyParseConditions(query.steps, contextData)

    query.sources = parsedSources;
    query.steps = parsedSteps;

    return query
}

interface IExecuteSettings {
    disableParseParameters?: boolean
}
export async function executeAndBind(context: IContextProvider, source: IDataSourceBinding, sources: IDataSource[], parameters: any, contextData?: any, settings: IExecuteSettings = {}) {
    let ds = findDataSource(source?.source, sources);
    if (!ds) throw 'Unable to find data source: ' + source?.source;

    let result: any = null

    if (ds.type == 'custom-json') result = ds.json || {}

    else if (ds.type == 'model-action') {
        if (!settings?.disableParseParameters) {
            let sourceParameters = ds.parameters;
            for (let p of sourceParameters) {
                parameters[p.id] = parseValue(p.value, contextData || {});
            }
        }

        result = await context.executeAction(ds.model, ds.action, parameters, { json: true });
    }
    else if (ds.type === 'model-collection') {
        // check if we have filters
        const hasFiltering = (ds.filter && Object.keys(ds.filter).length > 0)
        const hasGrouping = (ds.grouping && ds.grouping.length > 0)

        let filter = {};
        if (hasFiltering) {
            filter = interpolateFilters(ds.filter, contextData);
        }
        let service = 'Aggregate'
        parameters['model'] = ds.modelKey
        parameters['collectionName'] = ds.action

        if (hasGrouping) {
            let groups = ds.grouping || []
            groups = groups.filter(g => !('$match' in g))
            if (hasFiltering) {
                groups.unshift({ "$match": filter })
            }
            parameters['stages'] = JSON.stringify(groups)
            service = 'Aggregate'
        }
        else {
            // just filtering
            if (parameters.hasOwnProperty('last') && parameters['last'] == null) {
                parameters['last'] = '0'
            }
            parameters['filter'] = JSON.stringify(filter || {})
            service = 'GetPaginatedDocs'
        }

        result = await context.executeService('Lucy', service, parameters, { json: true })
        result = tryParseJSON(result[0].data)
    }
    else if (ds.type === 'external-database') {
        const DBService = 'ExternalDatabase'
        const hasGrouping = (ds.grouping && ds.grouping.length > 0)
        let filter = interpolateFilters(ds?.filter || {}, contextData);
        let route = `/v1/database/${ds.databaseId}/data`
        parameters['filters'] = JSON.stringify(filter || {})
        if (parameters.hasOwnProperty('last') && parameters['last'] == null) {
            parameters['last'] = '0'
        }

        if (hasGrouping) {
            parameters['stages'] = JSON.stringify(ds.grouping || [])
            route = `/v1/database/${ds.databaseId}/aggregate`
        }
        result = await context.executeComponent(DBService, route, 'get', parameters,)
    }
    else if (ds.type === 'query') {
        const QueryEngineService = 'QueryEngine'
        const route = `/v1/execution`

        const parsedQuery = parseQuery(cloneDeep(ds?.query || { sources: [], steps: [] }), contextData)
        const response = await context.executeComponent(QueryEngineService, route, 'post', {}, parsedQuery)
        result = response.result
    }
    let path = source.path || '';
    if (!path || path == '$') {
        return result;
    }
    //Total utter hack because jsonpath can't handle .[x]
    var pathEx = path.replace(/\.\[/g, '[');
    let results = (jsonpath as any).default.query(result, pathEx, 1);
    return results?.[0] || null;
}

export function getSchemaFromFields(fields: { name: string, type: string }[]) {

    const properties: any = {}
    for (const f of fields) {
        properties[f.name] = { type: f.type }
    }

    return {
        type: 'array',
        items: {
            type: 'object',
            properties: properties,
            required: Object.keys(properties)
        }
    }

}

export function extractSchemaFromInitialSource(source: ICollection | IModelAction) {

    let schema: any = null
    if (!!source.OutputSchema) schema = tryParseJSON(source.OutputSchema)

    if (!schema) {
        // if schem not found
        // generate from colllection
        if (isModelCollection(source) || isExternalDatabase(source)) {
            // if there aggregation schema should have set, skipping that for now
            // set the schema

            const attributes = ((source as ICollection).Attributes || []).map((a: any) => ({ name: a.name, type: a.dataType }))
            schema = getSchemaFromFields(attributes)

        }
        else {
            // generate from action
            // skip for now
        }
    }
    return schema
}

export function createDataSourceFromAction(x: ModelDefinition, inputs?: any[]): IDataSource {
    const actionDefinition = x ? tryParseJSON(x.Definition, null) : null
    if (!actionDefinition) return null

    const params: IDataSourceParameter[] = (actionDefinition?.parameters || []).map((x: string) => {
        let value = ''
        if (!!inputs) {
            const inst = inputs.find((i: any) => i.name === x)
            if (inst) value = inst.value
        }
        return { id: x, description: x, value: value, type: '', example: '' }
    })

    return {
        id: null,
        model: x.Name,
        action: x.Action,
        parameters: params,
        description: x.Docs,
        schema: tryParseJSON(x.OutputSchema, DEFAULT_SCHEMA),
        type: 'model-action',
        icon: x.Icon || DEFAULT_ICON
    }
}

async function processToModelAction(uxpContext: IContextProvider, uiProps: any, initSource: IModelAction, target: TargetDataStructure, datasources: IDataSource[], existingDSId?: string) {
    const { Name, Action, Inputs } = initSource

    const response = await uxpContext.executeService('UXP', 'WidgetTemplate:GetModelSource', { model: Name, action: Action }, { json: true });

    const _source = createDataSourceFromAction(response[0], Inputs)
    _source.__source__ = initSource

    // use an existing path if provided
    let bindingPath = initSource?.SelectedPath || deriveJSONPath(_source.schema, null, target);

    //If the exact schema did not match, try and find out
    if (!validateSchema(schemaAtJsonPath(_source.schema, bindingPath), target)) {
        if (!initSource?.SelectedPath) {
            throw 'Schema at given path does not match target: ' + bindingPath + ':' + target;
        }

        let innerPath = deriveJSONPath(schemaAtJsonPath(_source.schema, bindingPath), null, target);
        bindingPath = combinePaths(initSource?.SelectedPath, innerPath);
        if (!validateSchema(schemaAtJsonPath(_source.schema, bindingPath), target)) {
            throw 'Could not match schema to expected target';
        }
    }

    const source = registerDataSource(_source, existingDSId);
    const binding: IDataSourceBinding = {
        path: bindingPath,
        source: source.id,
    };
    const newSources = (datasources || []).slice().filter(s => s.id !== source.id);
    newSources.push(source);

    const title = { text: `${Name} - ${Action}` };
    return Object.assign({}, uiProps, { datasources: newSources, source: binding, title });
}

async function processToExternalDB(uiProps: any, initSource: ICollection, target: TargetDataStructure, datasources: IDataSource[], existingDSId?: string) {
    const _source: IExternalDatabaseDataSource = {
        id: null,
        model: initSource.Name,
        action: initSource.Action,
        modelKey: initSource.MapKey,
        databaseId: initSource.ID,
        parameters: initSource.Attributes.map((a: any) => ({ id: a.name, description: a.name, value: '' })),
        description: initSource.Description,
        schema: extractSchemaFromInitialSource(initSource) || DEFAULT_SCHEMA,
        type: 'external-database',
        grouping: initSource.Grouping,
        filter: initSource.Filter,
        __source__: initSource,
        icon: DEFAULT_ICON,
    }

    const bindingPath = deriveJSONPath(_source.schema, null, target);
    const source = registerDataSource(_source, existingDSId);

    const binding: IDataSourceBinding = {
        path: bindingPath,
        source: source.id,
    };

    const newSources = (datasources || []).slice().filter(s => s.id !== source.id);
    newSources.push(source);
    return Object.assign({}, uiProps, { datasources: newSources, source: binding });
}

async function processToModelCollection(uiProps: any, initSource: ICollection, target: TargetDataStructure, datasources: IDataSource[], existingDSId?: string) {
    const _source: IModelCollectionDataSource = {
        id: null,
        model: initSource.Name,
        modelKey: initSource.MapKey,
        action: initSource.Action,
        parameters: initSource.Attributes.map((a: any) => ({ id: a.name, description: a.name, value: '' })),
        description: initSource.Description,
        schema: extractSchemaFromInitialSource(initSource) || DEFAULT_SCHEMA,
        type: 'model-collection',
        grouping: initSource.Grouping,
        filter: initSource.Filter,
        __source__: initSource,
        icon: DEFAULT_ICON,
    }

    const bindingPath = deriveJSONPath(_source.schema, null, target);
    const source = registerDataSource(_source, existingDSId);

    const binding: IDataSourceBinding = {
        path: bindingPath,
        source: source.id,
    };

    const newSources = (datasources || []).slice().filter(s => s.id !== source.id);
    newSources.push(source);
    return Object.assign({}, uiProps, { datasources: newSources, source: binding });
}

async function processToQuery(uiProps: any, initSource: IQueryDataSource, target: TargetDataStructure, datasources: IDataSource[], existingDSId?: string) {
    console.log('initial_sou', initSource)
    const _source: IQueryDataSource = {
        id: null,
        description: initSource.description,
        parameters: [],
        query: initSource.query,
        name: initSource.name,
        type: 'query',
        schema: initSource.schema,
        __source__: {
            name: initSource.name,
            query: initSource.query,
            description: initSource.description,
            schema: initSource.schema
        }
    }

    const bindingPath = deriveJSONPath(_source.schema, null, target);
    const source = registerDataSource(_source, existingDSId);

    const binding: IDataSourceBinding = {
        path: bindingPath,
        source: source.id,
    };

    const newSources = (datasources || []).slice().filter(s => s.id !== source.id);
    newSources.push(source);
    return Object.assign({}, uiProps, { datasources: newSources, source: binding });
}


// this is to process the sources comming from outside (EX: canvas))
// Assume for now we will only get ModelActions. ModelCollections and ExternalDatabases
export async function processSource(designer: IWDDesignModeProps, uxpContext: IContextProvider, uiProps: any, initSource: any, target: TargetDataStructure, datasources: IDataSource[], existingDSId?: string) {
    if (designer?.mode != 'preview') return null;
    if (!initSource) return null;

    // get source details
    let _datasources = [...(datasources || [])]
    if (!_datasources || _datasources.length == 0) _datasources = uiProps?.datasources || []

    // now we will get Query also as a initial source - this will fully parsed as a source
    if (initSource.hasOwnProperty('type') && initSource.type == 'query') return processToQuery(uiProps, initSource, target, datasources, existingDSId)

    if (isModelCollection(initSource)) return processToModelCollection(uiProps, initSource, target, datasources, existingDSId)
    if (isExternalDatabase(initSource)) return processToExternalDB(uiProps, initSource, target, datasources, existingDSId)
    else return processToModelAction(uxpContext, uiProps, initSource, target, datasources, existingDSId)
}


export async function processInitialSource(designer: IWDDesignModeProps, uxpContext: IContextProvider, uiProps: any, initialSource: string, target: TargetDataStructure) {
    if (designer?.mode != 'preview') return null;
    if (!initialSource) return null;

    // get source details
    let initSource = tryParseJSON(initialSource);

    try {
        return processSource(designer, uxpContext, uiProps, initSource, target, []);
    } catch (e) {
        console.log('Unable to process the initial source ', e);
    }
}
